import React from 'react';
import Layout from "../../shared/components/layouts/MainLayout";
import { segmentEventTracker } from "../../../utils/SegmentEventTracker";
import { TrackEventName } from "../../shared/constants/SegmentEvents";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { isEmpty } from 'lodash';

import FullScreenLoading from '../../shared/components/misc/FullScreenLoading';
import { fetchCreditLimit, fetchCreditLine, fetchFcPayment } from '../../CreditLimit/actions';
import DrawDownCustomization from '../components/DrawDownCustomization'

export class DrawDown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: true };
    this.onCreditLimitSuccess = this.onCreditLimitSuccess.bind(this);
    this.onCreditLineSuccess = this.onCreditLineSuccess.bind(this);
  }

  componentDidMount() {
    if(this.fcPaymentId) {
      this.props.fetchFcPayment(this.fcPaymentId);
    }
    this.props.fetchCreditLimit(this.onCreditLimitSuccess);
  }

  get fcPaymentId() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return params.fc_payment_id;
  }

  onCreditLimitSuccess(_response, validatorResponse) {
    if (!validatorResponse) return this.props.push('/');

    this.props.fetchCreditLine(this.onCreditLineSuccess);
  }

  onCreditLineSuccess(_response, validatorResponse) {
    if (!validatorResponse) return this.props.push('/');

    this.setState({loading: false});
  }

  backButtonAction = () => {
    segmentEventTracker.trackEvent(TrackEventName.BACK_CLICKED);

    this.props.push('/');
  };

  get isLoading() {
    const { loadingCreditLimit, loadingCreditLine, loadingPayment } = this.props;

    const requirements = [loadingCreditLimit, loadingCreditLine, loadingPayment];
    const isLoading = (loading) => loading === true;

    return requirements.some(isLoading) || this.state.loading;
  }

  get isForPayment() {
    return !isEmpty(this.props.fc_payment);
  }

  get header() {
    if (this.isForPayment) { return 'Customize Payment Details' }

    return 'Customize your loan details'
  }

  render() {
    if (this.isLoading) return <FullScreenLoading />

    return (
      <Layout
        gridClassName='--ultraWide'
        backButtonAction={this.backButtonAction}
        header={this.header}
      >
        <DrawDownCustomization />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loadingCreditLimit: state.shared.ui.loading.creditLimit,
    loadingCreditLine: state.shared.ui.loading.creditLine,
    loadingPayment: state.shared.ui.loading.payment,
    fc_payment: state.fc_payment,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchCreditLine: (onSuccess) => dispatch(fetchCreditLine(onSuccess)),
    fetchCreditLimit: (onSuccess) => dispatch(fetchCreditLimit(onSuccess)),
    fetchFcPayment: (fcPaymentId, onSuccess) => dispatch(fetchFcPayment(fcPaymentId, onSuccess)),
    push: (url) => dispatch(push(url)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DrawDown);



// WEBPACK FOOTER //
// ./src/features/loans/containers/DrawDown.js